import React, { useState, useContext, useRef, useEffect } from "react";
import { timesheetsRef, restoresRef, quotesRef, jobsheetsRef } from "../firebase";
// import { v4 as uuidv4 } from "uuid";
// import { SettingsContext } from "../providers/SettingsProvider";
import { useHistory } from "react-router-dom";
import { RestoresContext } from "../providers/RestoresProvider";
import PrimarySection from "./PrimarySection";
import {
  permanentPrimaryDelete,
  transferTimesheets,
  cloneTimesheets,
} from "../helperFunctions/dbFunctions";
import Footer from "./Footer";
import { useSectionedData } from "../customHooks/useSectionedData";
import { useEditMode } from "../customHooks/useEditMode";
import SearchSortFilterBar from "./SearchSortFilterBar";

import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import RestoreIcon from "@mui/icons-material/Restore";

import EditIcon from "@mui/icons-material/Edit";

import "../css/primariesPage.scss";
// import NoTimesheets from "./NoTimesheets";
import Loading from "./Loading";
import { tooltips } from "../popData";
import FooterBtn from "./FooterBtn";
import CloneOptions from "./CloneOptions";
import { SlidersContext } from "../providers/SlidersProvider";
import SliderWrapper, { SliderContainer } from "./SliderWrapper";

import { useViewWindowExtender } from "../customHooks";

const Restores = () => {
  // const [inEditMode, toggleEditMode] = useState(false);
  // const [markedTimesheets, editMarkedTimesheets] = useState([]);
  const { timesheets, loading } = useContext(RestoresContext);

  const containerRef = useRef(null);
  const { sliders, setSliderId, sliderId } = useContext(SlidersContext);

  const [sortAndFilterOptions, setSortAndFilterOptions] = useState({
    searchTerm: "",
    sortBy: "refNumber", // Options: refNumber, jobReceived, created
    customerFilter: "all",
    statusFilter: "all",
    quarterFilter: "all",
    order: true,
    viewWindow: 3,
  });

  useEffect(() => {
    // Will remove slider when nvaigating between primaries
    // ie. quotes => timesheets
    setSliderId(null);
  }, []);

  const sectionedTimesheets = useSectionedData(timesheets, sortAndFilterOptions);

  // Show footer conditions >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let showFooter = true;

  // if (sliders && window.sessionStorage.getItem("currentPrimary")) {
  if (sliders && sliderId) {
    showFooter = false;
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  const { inEditMode, toggleEditMode, isMarked, markMonth, markItem, markedItems, editMarkedItems } =
    useEditMode();

  const history = useHistory();

  // Enables infinite scroll like behaviour >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const [endOfViewWindow] = useViewWindowExtender(
    timesheets,
    sortAndFilterOptions,
    setSortAndFilterOptions,
    sectionedTimesheets,
    sliderId,
  );
  // Enable infinite scroll like behaviour <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  // function activateEditMode() {
  //   toggleEditMode();
  // }

  // function isMarked(timesheetId) {
  //   let marked = false;
  //   if (markedTimesheets.includes(timesheetId)) {
  //     marked = true;
  //   }

  //   return marked;
  // }

  // function handleInEditMode(timesheetId) {
  //   editMarkedTimesheets(timesheets => {
  //     if (isMarked(timesheetId)) {
  //       return timesheets.filter(tsId => tsId !== timesheetId);
  //     } else {
  //       return [...timesheets, timesheetId];
  //     }
  //   });
  // }

  function editTimesheet(timesheet) {
    let timesheetId = timesheet.uid;
    if (inEditMode) {
      markItem(timesheet);
      //      markTimesheet(timesheet);
    } else {
      if (sliders) {
        // If sliders are on, add chosen primary id to session storage
        setSliderId(timesheetId);
      }
      history.push(`/restore/${timesheetId}`, { timesheet });
    }
  }

  // function markTimesheet(timesheet) {
  //   let timesheetId = timesheet.uid;

  //   editMarkedTimesheets(marked => {
  //     if (isMarked(timesheetId)) {
  //       return marked.filter(uid => uid !== timesheetId);
  //     } else {
  //       return [...marked, timesheetId];
  //     }
  //   });
  // }

  // function markMonth(timesheets) {
  //   timesheets.forEach(ts => {
  //     markTimesheet(ts);
  //   });
  // }

  async function clone(e) {
    let cloneType = e.target.dataset.clonetype || "all";

    await cloneTimesheets(markedItems, cloneType, restoresRef, restoresRef, "timesheet", vat);
    editMarkedItems([]);
    toggleEditMode(containerRef.current);
  }

  async function convertToTimesheets() {
    await transferTimesheets(markedItems, restoresRef, timesheetsRef, "timesheet");
    editMarkedItems([]);
    toggleEditMode(containerRef.current);
  }

  async function convertToQuotes() {
    await transferTimesheets(markedItems, restoresRef, quotesRef, "quote");
    editMarkedItems([]);
    toggleEditMode(containerRef.current);
  }

  async function convertToJobsheets() {
    await transferTimesheets(markedItems, restoresRef, jobsheetsRef, "jobsheet");
    editMarkedItems([]);
    toggleEditMode(containerRef.current);
  }

  async function deleteTimesheets() {
    await permanentPrimaryDelete(markedItems, restoresRef);
    editMarkedItems([]);
    toggleEditMode(containerRef.current);
  }

  let areItemsChosen = inEditMode && markedItems.length > 0;

  if (loading) {
    return <Loading />;
  }

  return (
    <div ref={containerRef} className="primariesPage">
      <SearchSortFilterBar options={sortAndFilterOptions} setOptions={setSortAndFilterOptions} />

      {showFooter && (
        <Footer back={false} title="Restores">
          <FooterBtn
            title={tooltips.edit}
            cb={() => toggleEditMode(containerRef.current)}
            isActive={inEditMode}
          >
            <EditIcon style={{ fontSize: 25 }} />
          </FooterBtn>

          {areItemsChosen && <CloneOptions clone={clone} inEditMode={inEditMode} />}

          <FooterBtn title={tooltips.restoreToTimesheets} cb={convertToTimesheets} show={areItemsChosen}>
            <RestoreIcon title="Restore to Timesheets" style={{ fontSize: 28 }} />
            <span>T</span>
          </FooterBtn>

          <FooterBtn title={tooltips.restoreToQuotes} cb={convertToQuotes} show={areItemsChosen}>
            <RestoreIcon title="Restore to Quotes" style={{ fontSize: 28 }} />
            <span>Q</span>
          </FooterBtn>

          <FooterBtn title={tooltips.restoreToJobsheets} cb={convertToJobsheets} show={areItemsChosen}>
            <RestoreIcon title="Restore to Jobsheets" style={{ fontSize: 28 }} />
            <span>J</span>
          </FooterBtn>

          <FooterBtn title={tooltips.binForever} cb={deleteTimesheets} show={areItemsChosen}>
            <DeleteOutlinedIcon style={{ fontSize: 28 }} />
          </FooterBtn>
        </Footer>
      )}

      {/* {sectionedTimesheets.length === 0 && <NoTimesheets />} */}

      <SliderWrapper>
        <>
          <div className={`primariesList ${inEditMode ? "dimSheets" : ""}`}>
            {sectionedTimesheets.map(({ title, data }) => {
              return (
                <PrimarySection
                  key={title}
                  title={title}
                  data={data}
                  markMonth={markMonth}
                  editPrimary={editTimesheet}
                  isMarked={isMarked}
                  primarySectionType={"restore"}
                />
              );
            })}

            <div ref={endOfViewWindow}></div>
          </div>
        </>

        <SliderContainer primaryType="restore" />
      </SliderWrapper>

      {/* <h2>Restores</h2>
      <button onClick={activateEditMode}>edit mode</button>
      {inEditMode && <button onClick={deleteTimesheets}>delete</button>}
      {inEditMode && <button onClick={convertTimesheets}>convert</button>}
      {/* <button onClick={deleteTimesheets}>edit mode</button> */}
      {/* <p>in edit mode {String(inEditMode)}</p> */}

      {/*  */}
      <p>
        {/* {sectionedTimesheets.map(({ title, data }) => {
          return (
            <div key={title}>
              <h4 onClick={() => markMonth(data)} className="sectionTitle">
                {title}
              </h4>

              {data.map((ts) => {
                let { refNumber, uid } = ts;
                let marked = isMarked(uid);

                return (
                  <div
                    className="timesheetCard"
                    style={marked ? markedTimesheet : unmarkedTimesheet}
                    onClick={() => editTimesheet(ts)}
                    key={uid}
                  >
                                       <p>{refNumber}</p>
                  </div>
                );
              })}
            </div>
          );
        })} */}
      </p>

      {/*  */}

      {/* <div>
      {timesheets.map(timesheet => {
        let { refNumber, uid } = timesheet;
        let marked = false;
        if (isMarked(uid)) {
          marked = true;
        }

        return (
          <div
            style={marked ? markedTimesheet : unmarkedTimesheet}
            onClick={() => editTimesheet(timesheet)}
            key={uid}
          >
        
            <p>{refNumber}</p>
          </div>
        );
      })}
      </div>
       */}
    </div>
  );
};

export default Restores;
